{
  "title": "Appointments",
  "description": "View and manage your appointments",
  "searchPlaceholder": "Search appointments...",
  "emptyTitle": "No Appointments Yet",
  "emptyDescription": "You haven't received any appointments yet. When customers book your services, they will appear here.",
  "viewDetails": "View Details",
  "columns": {
    "customer": "Customer",
    "service": "Service",
    "date": "Date",
    "time": "Time",
    "status": "Status",
    "booking": "Booking"
  },
  "status": {
    "all": "All",
    "pending": "Pending",
    "active": "Active",
    "inProgress": "In Progress",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "expired": "Expired",
    "rescheduleRequested": "Reschedule Requested",
    "approved": "Approved",
    "rejected": "Rejected",
    "reported": "Reported"
  },
  "show": {
    "title": "Appointment Details",
    "documentTitle": "{{name}} Appointment",
    "documentTitleFallback": "Appointment Details",
    "description": "View appointment information for {{service}}",
    "thisService": "this service",
    "actions": "Actions",
    "requestReschedule": "Request Reschedule",
    "sendingRequest": "Sending Request...",
    "notFoundTitle": "Appointment Not Found",
    "notFoundDescription": "The appointment you are looking for could not be found.",
    "loadFailed": "Failed to load appointment",
    "backToAppointments": "Back to Appointments",
    "date": "Date",
    "time": "Time",
    "serviceInformation": "Service Information",
    "serviceName": "Service Name",
    "unit": "Unit",
    "rating": "Rating",
    "customer": "Customer",
    "serviceProvider": "Service Provider",
    "noEmail": "No email",
    "quickActions": "Quick Actions",
    "emailCustomer": "Email Customer",
    "idNotFound": "Appointment ID not found",
    "rescheduleSuccess": "Reschedule request sent successfully",
    "rescheduleFailed": "Failed to reschedule appointment",
    "markInProgress": "Mark in progress",
    "markingInProgress": "Marking in progress...",
    "inProgressSuccess": "Appointment marked in progress",
    "inProgressFailed": "Failed to mark appointment in progress",
    "complete": "Mark complete",
    "completing": "Completing...",
    "completeSuccess": "Appointment marked complete",
    "completeFailed": "Failed to complete appointment",
    "cancelAppointment": "Cancel appointment",
    "cancelling": "Cancelling...",
    "cancelSuccess": "Appointment cancelled",
    "cancelFailed": "Failed to cancel appointment",
    "acceptReschedule": "Accept reschedule",
    "acceptingReschedule": "Accepting...",
    "acceptRescheduleSuccess": "Reschedule accepted",
    "acceptRescheduleFailed": "Failed to accept reschedule",
    "rejectReschedule": "Reject reschedule request",
    "rejectingReschedule": "Rejecting...",
    "rejectRescheduleSuccess": "Reschedule request rejected",
    "rejectRescheduleFailed": "Failed to reject reschedule request",
    "initiateAdditionalFee": "Request additional fee",
    "initiateAdditionalFeeDescription": "Request an additional payment from the customer for this appointment.",
    "feeAmount": "Amount",
    "feeAmountInvalid": "Enter a valid amount greater than zero",
    "initiateFee": "Send request",
    "initiatingFee": "Sending...",
    "feeInitiatedSuccess": "Additional fee request sent",
    "feeInitiatedFailed": "Failed to request additional fee",
    "notes": "Notes",
    "notePlaceholder": "Add a note about this appointment...",
    "addNote": "Add note",
    "addingNote": "Adding...",
    "noteRequired": "Enter a note before saving",
    "noteAddedSuccess": "Note added",
    "noteAddedFailed": "Failed to add note",
    "notesLoadFailed": "Failed to load notes",
    "noNotes": "No notes yet",
    "reschedulePendingHint": "Waiting for customer to accept the proposed reschedule."
  },
  "bookAppointment": "Book appointment",
  "bookForCustomer": "Book for this customer",
  "booking": {
    "title": "Book appointment",
    "adminTitle": "Book appointment (admin)",
    "description": "Create an appointment on behalf of a customer.",
    "adminDescription": "Select a business, then book an appointment for one of its customers.",
    "success": "Appointment booked successfully",
    "loadingSlots": "Loading available times...",
    "noSlots": "No available times for this date.",
    "freeServiceHint": "This service is free — no payment step is required.",
    "customer": {
      "createNew": "New customer",
      "searchExisting": "Existing customer"
    },
    "steps": {
      "customer": { "title": "Customer", "description": "Find or create the customer." },
      "service": { "title": "Service", "description": "Choose service and provider." },
      "schedule": { "title": "Date & time", "description": "Pick an available slot." },
      "payment": { "title": "Payment", "description": "Choose how the booking is paid." },
      "confirm": { "title": "Confirm", "description": "Review and submit." }
    },
    "fields": {
      "business": "Business",
      "customerName": "Customer name",
      "customerEmail": "Email",
      "customerPhone": "Phone",
      "customerSearch": "Search customers",
      "customerSearchPlaceholder": "Search by name, email, or phone",
      "customerSelectPlaceholder": "Select a customer",
      "service": "Service",
      "servicePlaceholder": "Select a service",
      "provider": "Provider (optional)",
      "providerPlaceholder": "Any available provider",
      "date": "Date",
      "timeSlot": "Time slot",
      "paymentMode": "Payment mode",
      "momoNumber": "Mobile money number",
      "momoNetwork": "Network (MTN, Vodafone, etc.)",
      "paymentMethodId": "Saved payment method ID",
      "paymentMethodIdPlaceholder": "Customer's saved card or MoMo method ID",
      "paymentMethodIdHint": "Use a saved payment method ID instead of entering MoMo details, or leave blank to charge the number above.",
      "staffNotes": "Staff notes",
      "staffNotesPlaceholder": "Reception notes (optional)"
    },
    "paymentModes": {
      "offline": "Offline / cash",
      "payment_link": "Send payment link",
      "staff_online": "Staff-entered MoMo"
    },
    "actions": {
      "back": "Back",
      "next": "Next",
      "confirm": "Confirm booking",
      "submitting": "Booking..."
    },
    "errors": {
      "businessRequired": "Select a business first",
      "customerRequired": "Customer could not be resolved",
      "slotRequired": "Select a time slot",
      "loadSlots": "Could not load available times",
      "submit": "Could not complete booking"
    },
    "audit": {
      "bookedBy": "Booked by {{name}}",
      "sourceConsole": "Staff console",
      "sourceProvider": "Provider app",
      "sourceAdmin": "Platform admin",
      "sourceCustomer": "Customer app",
      "sourceUnknown": "Staff booking",
      "paymentUnknown": "Staff payment",
      "sourceConsoleShort": "Console",
      "sourceProviderShort": "Provider app",
      "sourceAdminShort": "Admin",
      "staffBooked": "Staff booked"
    },
    "intake": {
      "title": "Intake questions",
      "description": "Answer any required questions for this service.",
      "required": "This question is required"
    }
  }
}
